import script from "./ConfigTumorBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigTumorBoard.vue?vue&type=script&setup=true&lang=js"

import "./ConfigTumorBoard.vue?vue&type=style&index=0&id=7334b77f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7334b77f"]])

export default __exports__